const docsRouters = [
  // 文档管理
  {
    path: 'docs',
    name: 'Docs',
    redirect: '/manage/docs/home',
    component: () => import(/* webpackChunkName: "DocsMain" */ '@/views/docs/index'),
    meta: {
      sidebar: false,
      // 可查看文档的列表
      authKey: ['auth_docs', 'auth_docs_home_list_all'],
      title: 'com_sider_menu_docs',
      disabled: false,
      icon: 'menu_docs',
    },
    children: [
      // 文档 - 首页
      {
        path: 'home',
        name: 'DocsHome',
        component: () => import(/* webpackChunkName: "DocsHome" */ '@/views/docs/home'),
        meta: {
          sidebar: false,
          authKey: ['auth_docs', 'auth_docs_home_list_all'],
          title: 'com_sider_menu_docs',
          breadcrumb: false,
          disabled: false,
          icon: 'menu_docs',
        },
      },

      // 文档 - 搜索
      {
        path: 'search',
        name: 'DocsSearch',
        component: () => import(/* webpackChunkName: "DocsSearch" */ '@/views/docs/search.vue'),
        meta: {
          sidebar: false,
          authKey: ['auth_docs', 'auth_docs_home_list_all', 'auth_docs_search'],
          title: 'com_sider_menu_docs_search',
          breadcrumb: false,
          disabled: false,
          icon: 'menu_docs',
        },
      },

      // 文档 - 详情
      {
        path: 'detail/:id?',
        name: 'DocsDetail',
        component: () => import(/* webpackChunkName: "DocsDetail" */ '@/views/docs/detail'),
        meta: {
          sidebar: false,
          authKey: ['auth_docs', 'auth_docs_detail'],
          title: 'docs_detail_title',
          breadcrumb: true,
          disabled: false,
          icon: 'menu_docs',
          autoCollect: false,
        },
      },

      // 文档 - 详情
      {
        path: 'detail/type/:type?',
        name: 'DocsDetailType',
        component: () => import(/* webpackChunkName: "DocsDetail" */ '@/views/docs/detail'),
        meta: {
          sidebar: false,
          authKey: ['auth_docs', 'auth_docs_detail'],
          title: 'docs_detail_title',
          breadcrumb: true,
          disabled: false,
          icon: 'menu_docs',
          autoCollect: false,
        },
      },

      // 文档 - 列表
      {
        path: 'list',
        name: 'DocsList',
        component: () => import(/* webpackChunkName: "DocsList" */ '@/views/docs/list'),
        meta: {
          sidebar: false,
          authKey: ['auth_docs', 'auth_docs_manage', 'auth_docs_list'],
          title: 'com_sider_menu_docs_list',
          breadcrumb: false,
          disabled: false,
          icon: 'menu_docs',
        },
      },

      // 文档 - 属性详情
      {
        path: 'props/:id?',
        name: 'DocsProps',
        component: () => import(/* webpackChunkName: "DocsDetail" */ '@/views/docs/props'),
        meta: {
          sidebar: false,
          authKey: ['auth_docs', 'auth_docs_manage', 'auth_docs_detail'],
          title: 'docs_detail_title',
          breadcrumb: true,
          disabled: false,
          icon: 'menu_docs',
          autoCollect: false,
        },
      },

      // 文档 - 添加(实际为添加属性)
      {
        path: 'add',
        name: 'DocsPropsAdd',
        component: () => import(/* webpackChunkName: "DocsPropsAdd" */ '@/views/docs/updateProps'),
        meta: {
          sidebar: false,
          authKey: ['auth_docs', 'auth_docs_manage', 'auth_docs_add'],
          title: 'docs_add_title',
          breadcrumb: true,
          disabled: false,
          icon: 'menu_docs',
          autoCollect: false,
        },
      },

      // 文档 - 属性编辑
      {
        path: 'update/props/:id?',
        name: 'DocsPropsUpdate',
        component: () =>
          import(/* webpackChunkName: "DocsPropsUpdate" */ '@/views/docs/updateProps'),
        meta: {
          sidebar: false,
          authKey: ['auth_docs', 'auth_docs_manage', 'auth_docs_edit'],
          title: 'docs_update_title',
          breadcrumb: true,
          disabled: false,
          icon: 'menu_docs',
          autoCollect: false,
        },
      },

      // 文档 - 编辑内容
      {
        path: 'update/content/:categoryId/:id',
        name: 'DocsContentUpdate',
        component: () =>
          import(/* webpackChunkName: "DocsContentUpdate" */ '@/views/docs/updateContent'),
        meta: {
          sidebar: false,
          authKey: ['auth_docs', 'auth_docs_manage', 'auth_docs_content_edit'],
          title: 'docs_update_title',
          breadcrumb: true,
          disabled: false,
          icon: 'menu_docs',
          autoCollect: false,
        },
      },

      // 文档 - 分类管理(编辑/添加使用弹窗的模式)
      {
        path: 'category',
        name: 'DocsCategory',
        component: () => import(/* webpackChunkName: "DocsCategory" */ '@/views/docs/category'),
        meta: {
          sidebar: false,
          authKey: ['auth_docs', 'auth_docs_manage', 'auth_docs_category_manage'],
          title: 'docs_update_title',
          breadcrumb: true,
          disabled: false,
          icon: 'menu_docs',
          autoCollect: false,
        },
      },
    ],
  },
];
export default docsRouters;
